import { Radio, styled } from '@mui/material';

export const RadioStyled = styled(Radio, {
  shouldForwardProp: (prop) => prop !== 'selectedValue',
})(({ theme }) => ({
  padding: 0,
  color: theme.palette.colors.mainFocused,

  '&.Mui-checked': {
    color: theme.palette.colors.highlight,
  },
  '&.Mui-disabled': {
    color: theme.palette.colors.secondaryDisabledText,
  },
}));
